import { render } from "./ProfileLearnContentSubpage.vue?vue&type=template&id=1b2be6e1&scoped=true"
import script from "./ProfileLearnContentSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileLearnContentSubpage.vue?vue&type=script&lang=js"

import "./ProfileLearnContentSubpage.vue?vue&type=style&index=0&id=1b2be6e1&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2be6e1"]])

export default __exports__